import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { BasePageComponent } from "../../../views/commons/base-page/base-page.component";
import { HelpersService } from "../../../core/helpers/helpers.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/platform-browser";
import { LabelP, CategoryP } from "../../../data/cms-vod-client-api";
import { DeviceDetectorService } from "ngx-device-detector";
import { Location } from "@angular/common";
import { DataSharingService } from "../../../core/data-sharing/data-sharing.service";
import { Subscription } from "rxjs";
import { VodDataRestService } from "../../../data/vod/vod-data-rest.service";
import { PodcastDataRestService } from "../../../data/podcast/podcast-data-rest.service";
import { PodcastGroup } from "../../../data/podcast-client-api/model/podcastContent";
import { SeoService } from "../../../data/seo/seo-service.service";
import { BlogDataRestService } from "../../../data/blog/blog-data-rest.service";
import { PostGroupP } from "../../../data/blog-client-api";

declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent
  extends BasePageComponent
  implements OnInit, OnDestroy
{
  public title = "Saat TV";
  // public searchType = '';
  public searchQuery = "";
  public userInfo: string;
  public info: any;
  static readonly CURRENT_USER_KEY = "AuthenticationService.currentUser";
  isAuthenticated: boolean;
  categories: CategoryP[];
  channelLists: any[];
  notificationMessages: any[] = [];
  // public get isAuthenticated() {
  //   return this.authService.isAuthenticated();
  // }
  viewMessage: any = {};
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  clearSubs: Subscription;
  categoryID: number;
  mainCategory: CategoryP = {};
  labels: LabelP[] = [];
  routerSubs: Subscription;
  selectedLabel: LabelP = {};
  podcastGroups: PodcastGroup[] = [];
  blogGroups: PostGroupP[] = [];

  constructor(
    private router: Router,
    helpers: HelpersService,
    private dataSharing: DataSharingService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private dataSource: VodDataRestService,
    private podcastService: PodcastDataRestService,
    private blogService: BlogDataRestService,
    private seoService: SeoService
  ) {
    super(helpers);
    this.isMobile = deviceService.isMobile();
    this.isTablet = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();

    this.clearSubs = dataSharing.clearSearchQuery$.subscribe((data) => {
      if (data) {
        this.searchQuery = "";
      }
    });

    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && !this.isMobile) {
        if (this.router.url.includes("dashboard/")) {
          this.getMenuLabels();
        } else if (
          this.router.url.includes("podcastGrid") ||
          this.router.url.includes("podcastDetail")
        ) {
          this.getPodcastGroups();
        } else if (
          this.router.url.includes("blog") ||
          this.router.url.includes("blogDetail")
        ) {
          this.getBlogGroups();
        } else {
          this.getMenuLabelsReq(true);
        }
      }
    });
  }

  ngOnInit() {
    $(document).ready(function () {
      // Transition effect for navbar
      $(window).scroll(function () {
        // checks if window is scrolled more than 10px, adds/removes solid class
        if ($(this).scrollTop() > 10) {
          $(".navbar").addClass("solid");
          $(".mobile-overlay-slider").addClass("black");
          $(".blog-player-container").addClass("solid");
        } else {
          $(".navbar").removeClass("solid");
          $(".mobile-overlay-slider").removeClass("black");
          $(".blog-player-container").removeClass("solid");
        }
      });
    });

    this.getActiveCategories();
  }

  submitSearch() {
    if (this.searchQuery.length > 2) {
      this.router.navigate(["/contentSearch", this.searchQuery]);
    } else if (this.searchQuery.length == 0) {
      this.router.navigate(["/"]);
    }
  }

  ngOnDestroy() {
    if (this.clearSubs) {
      this.clearSubs.unsubscribe();
      this.clearSubs = null;
    }

    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
      this.routerSubs = null;
    }

    if (this.routeSubs) {
      this.routeSubs.unsubscribe();
      this.routeSubs = null;
    }
  }

  getActiveCategories() {
    this.dataSource.getActiveCategories().subscribe((data) => {
      this.categories = data;
      this.mainCategory = this.categories.find((item) => item.main == true);
      this.getMenuLabels();
    });
    this.getMenuLabels();
  }

  routeSubs: Subscription;
  getMenuLabels() {
    if (
      this.router.url.includes("podcastGrid") ||
      this.router.url.includes("podcastDetail")
    ) {
      this.getPodcastGroups();
      return;
    }

    if (
      this.router.url.includes("blog") ||
      this.router.url.includes("blogDetail")
    ) {
      this.getBlogGroups();
      return;
    }
    this.routeSubs = this.route.children[0].params.subscribe((route) => {
      if (this.router.url.includes("dashboard")) {
        this.categoryID = route.id;
      }

      if (this.categoryID == -1) {
        this.getPodcastGroups();
        if (this.routeSubs) {
          this.routeSubs.unsubscribe();
          this.routeSubs = null;
        }
        return;
      }

      if (this.categoryID == -2) {
        this.getBlogGroups();
        if (this.routeSubs) {
          this.routeSubs.unsubscribe();
          this.routeSubs = null;
        }
        return;
      }

      if (!this.categoryID) {
        this.categoryID = this.mainCategory.id;
      }
      if (this.isMobile) {
        return;
      }
      this.getMenuLabelsReq();
    });
  }

  getMenuLabelsReq(isFromElse: boolean = false) {
    if (isFromElse) {
      this.categoryID = this.mainCategory.id;
    }
    this.dataSource.getMenuLabels(this.categoryID).subscribe((data) => {
      if (data) {
        this.labels = data;
        this.sendLabel();
        if (this.routeSubs) {
          this.routeSubs.unsubscribe();
          this.routeSubs = null;
        }
      }
    });
  }

  getPodcastGroups() {
    this.podcastService.getPodcastGroups().subscribe((data) => {
      if (data) {
        this.categoryID = -1;
        this.podcastGroups = data;
      }
    });
  }

  getBlogGroups() {
    this.blogService.getBlogGroups().subscribe((data) => {
      if (data) {
        this.categoryID = -2;
        this.blogGroups = data;
      }
    });
  }

  sendLabel() {
    setTimeout(() => {
      if (this.router.url.includes("contentGrid")) {
        this.dataSharing.sendLabelName(
          this.labels.find(
            (label) =>
              label.id == +this.route.children[0].snapshot.paramMap.get("id")
          ).name
        );
      }
    }, 100);
  }

  selectLabel(label: LabelP) {
    this.selectedLabel = label;
    this.seoService.generateTags({
      title: this.selectedLabel.name,
      description: this.selectedLabel.description,
      slug: this.selectedLabel.name,
      url: this.router.url,
    });
    this.sendLabel();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/widgets/header/header.component.ts